import { Document, DocumentType, Script } from '@talon/web/lib/api';
import { Box, Card, CardBody, CardHeader, Text } from 'grommet';
import { Close, Link } from 'grommet-icons';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { EditableText } from '..';
import { useProjectStore } from '../../../context';

export interface ICurrentDocumentProps {
  doc: Document;
  update: (update: Document) => Promise<void>;
  close: () => void;
}
export const CurrentDocument = observer(({ doc, update, close }: ICurrentDocumentProps) => {
  const [, setCurrentScript] = useState<Script | undefined>(undefined);
  const projectStore = useProjectStore();

  useEffect(() => {
    // fetch script
    const getScript = async () => {
      if (!doc || doc.type !== DocumentType.Script) {
        setCurrentScript(undefined);
        return;
      }
      const script = await projectStore.getScriptByDocId(doc.id);
      script && setCurrentScript(script);
    };
    getScript();
  }, [doc]);

  return (
    <Card pad="medium" background="light-2" margin="medium" round="medium">
      <CardHeader>
        <Box width="100%" direction="row" justify="end">
          <Close onClick={() => close()} style={{ cursor: 'pointer' }} />
        </Box>
      </CardHeader>
      <CardBody>
        <Box direction="column">
          <Box direction="row">
            <Text margin={{ right: 'small' }}>{doc.type}:</Text>
            <EditableText val={doc.name} onChange={(name) => update({ ...doc, name })} />
            <Link />
          </Box>
        </Box>
      </CardBody>
    </Card>
  );
});
